export default function Footer() {
  return (
    <footer className="bg-emerald-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">The Luxora Collection</h3>
            <p className="text-gray-600 mb-6">
              Premium health, wellness, and beauty products for your best life.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-emerald-800 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-emerald-800 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-emerald-800 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-colors">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-emerald-800 rounded-full flex items-center justify-center hover:bg-emerald-700 transition-colors">
                <i className="ri-pinterest-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Shop</h4>
            <ul className="space-y-3">
              <li><a href="#health" className="text-emerald-100 hover:text-white transition-colors">Health & Wellness</a></li>
              <li><a href="#skincare" className="text-emerald-100 hover:text-white transition-colors">Skincare</a></li>
              <li><a href="#personal" className="text-emerald-100 hover:text-white transition-colors">Personal Care</a></li>
              <li><a href="#natural" className="text-emerald-100 hover:text-white transition-colors">Natural Care</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Best Sellers</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">New Arrivals</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Customer Service</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Shipping Info</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Returns & Exchanges</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Track Order</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Size Guide</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">About Us</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Our Story</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Blog</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Careers</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Terms of Service</a></li>
              <li><a href="#" className="text-emerald-100 hover:text-white transition-colors">Affiliate Program</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm mb-4 md:mb-0">
            © 2024 The Luxora Collection. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="https://readdy.ai/?ref=logo" className="text-emerald-100 hover:text-white text-sm transition-colors">
              Powered by Readdy
            </a>
            <div className="flex space-x-3">
              <i className="ri-visa-line text-3xl text-emerald-100"></i>
              <i className="ri-mastercard-line text-3xl text-emerald-100"></i>
              <i className="ri-paypal-line text-3xl text-emerald-100"></i>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
